export default __webpack_public_path__ + "static/media/balance-bike.463b675c.jpg";